import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./admin_login.css";
import Loading1 from '../loading_animation/loading';

const AdminLogin = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    mail: "",
    password: "",
  });
  const [otpSent, setOtpSent] = useState(false);
  const [config, setConfig] = useState(null);
   const [isLoading, setIsLoading] = useState(false);

  // Load config.json
  useEffect(() => {
    fetch("/config.json")
      .then((res) => res.json())
      .then((data) => setConfig(data))
      .catch((err) => console.error("Error loading config:", err));
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSendOtp = async () => {
  try {
    setIsLoading(true); 
    const res = await fetch(`${config.BASE_URL}${config.ADMIN_SEND_OTP}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ mail: formData.mail }),
    });

    const data = await res.json();
    if (data.success) {
      alert("OTP sent to your email!");
      setOtpSent(true);
      setFormData((prev) => ({ ...prev, otpFromServer: data.otp }));
    } else {
      alert(data.message || "Failed to send OTP");
    }
  } catch (err) {
    console.error("OTP error:", err);
    alert("Error sending OTP. Please try again.");
  }
  finally {
      setIsLoading(false); 
    }
};


 const handleLogin = async () => {
  if (!formData.mail || !formData.password) {
    alert("Please enter email and password.");
    return;
  }

  if (!formData.otp) {
    alert("Please enter OTP.");
    return;
  }

  if (!config) {
    alert("Config not loaded yet. Please try again.");
    return;
  }

  try {
    setIsLoading(true);
    const res = await fetch(`${config.BASE_URL}${config.ADMIN_LOGIN}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify({
        mail: formData.mail,
        password: formData.password,
        otp: formData.otp, 
      }),
    });

    const data = await res.json();

    if (data.success) {
      alert("Login successful!");
      localStorage.setItem("admin_token", data.token);
      localStorage.setItem("admin_role", data.role);
      localStorage.setItem("admin_name", data.name);
      navigate("/rc_admin_panel");
    } else {
      alert(data.message || "Invalid credentials / OTP.");
    }
  } catch (err) {
    console.error("Login error:", err);
    alert("Error logging in. Please try again later.");
  }
  finally {
      setIsLoading(false);
    }
};

  return (
    <div className="admin-login">
      <h2>Admin Login</h2>
      <div className="form-container">
        <label>
          Email:
          <input
            type="email"
            name="mail"
            value={formData.mail}
            onChange={handleChange}
          />
        </label>
          {!otpSent && (
          <button type="button" onClick={handleSendOtp}>
            Send OTP
          </button>
        )}

          {otpSent && (
          <>
            <label>
              OTP:
              <input
                type="text"
                name="otp"
                value={formData.otp}
                onChange={handleChange}
              />
            </label>

            <label>
              Password:
              <input
                type="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
              />
            </label>

            <button onClick={handleLogin}>Login</button>
          </>
        )}
      </div>

            {isLoading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999
          }}
        >
          <Loading1 />
        </div>
      )}
      
    </div>
  );
};

export default AdminLogin;
